import { useState, useEffect, createContext, useContext } from 'react'
import { I18nContext } from './I18nProvider'
//API ENDPOINTS
import Api from '../api'
//Hooks
import useContextSelectedOptions from '../hooks/useContextSelectedOptions'

export const ItinerariesContext = createContext()

export const ItinerariesProvider = ({ children }) => {
    const { language } = useContext(I18nContext)

    const [selectedItinerarieID, setSelectedItinerarieID] = useState(null)

    //TODOS LOS ITINERARIOS

    //TODAS LAS OPCIONES PARA ALIMENTAR LOS SELECTS
    const [itinerariesOptions, setItinerariesOptions] = useState({
        destinations: [],
        types_of_travels: [],
        types_of_experiences: [],
        loading: true,
        error: null,
    })
    //OPCIONES SELECCIONADAS
    const [contextSelectedOptions, setContextSelectedOptions] = useContextSelectedOptions()

    useEffect(() => {
        const getSelectsOptions = async () => {
            try {
                const response = await Api.itineraries.options(language)

                setItinerariesOptions((prevOptions) => ({
                    ...prevOptions,
                    destinations: response.destinations,
                    types_of_travels: response.types_of_travels,
                    types_of_experiences: response.types_of_experiences,
                    loading: false,
                    error: false,
                }))
            } catch (error) {
                console.error(error)
                setItinerariesOptions((prevOptions) => ({
                    ...prevOptions,
                    error: error,
                }))
            }
        }
        getSelectsOptions()
    }, [language])

    return (
        <ItinerariesContext.Provider
            value={{
                itinerariesOptions,
                contextSelectedOptions,
                setContextSelectedOptions,
                selectedItinerarieID,
                setSelectedItinerarieID,
            }}
        >
            {children}
        </ItinerariesContext.Provider>
    )
}
